"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _UUID = _interopRequireDefault(require("./UUID"));

var _IntlMessages = _interopRequireDefault(require("./language-provider/IntlMessages"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DynamicTableOptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DynamicTableOptionList, _React$Component);

  var _super = _createSuper(DynamicTableOptionList);

  function DynamicTableOptionList(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DynamicTableOptionList);
    _this = _super.call(this, props);
    _this.state = {
      element: _this.props.element,
      data: _this.props.data,
      dirty: false
    };
    return _this;
  }

  (0, _createClass2["default"])(DynamicTableOptionList, [{
    key: "_setValue",
    value: function _setValue(text) {
      return text.replace(/[^A-Z0-9]+/ig, '_').toLowerCase();
    }
  }, {
    key: "updateTableOption",
    value: function updateTableOption(this_element) {
        var table_options_1 = [];
        this_element.table_rows.map(function (row, i) {
          var table_options_2 = [];
          this_element.table_columns.map(function (column, j) {
            table_options_2.push({
              value: 'table_option'+i+'_'+j,
              text: '',
              key: "table_option".concat(_UUID["default"].uuid())
            });
          });
          table_options_1.push(table_options_2);
        });
        this_element.table_options = table_options_1;
        this.props.updateElement.call(this.props.preview, this_element);
        this.setState({
            element: this_element,
            dirty: true
        });
    }
  }, {
    key: "editOptionRow",
    value: function editOptionRow(option_index, e) {
      var this_element = this.state.element;
      this_element.table_rows[option_index] = e.target.value;

      this.setState({
        element: this_element,
        dirty: true
      });
    }
  }, {
    key: "editOptionColumns",
    value: function editOptionColumns(option_index, e) {
      var this_element = this.state.element;
      this_element.table_columns[option_index] = e.target.value;
      
      this.setState({
        element: this_element,
        dirty: true
      });
    }
  }, {
    key: "editOptionDropdown",
    value: function editOptionDropdown(option_index, e) {
      var this_element = this.state.element;
      this_element.dropdown_options[option_index].text = e.target.value;
      this_element.dropdown_options[option_index].value = e.target.value;

      this.setState({
        element: this_element,
        dirty: true
      });
    }
  }, {
    key: "updateOption",
    value: function updateOption() {
      var this_element = this.state.element; // to prevent ajax calls with no change

      if (this.state.dirty) {
        this.props.updateElement.call(this.props.preview, this_element);
        this.setState({
          dirty: false
        });
      }
    }
  }, {
    key: "addOptionRow",
    value: function addOptionRow(index) {
      var this_element = this.state.element;
      this_element.table_rows.splice(index + 1, 0, '');
      this.updateTableOption(this_element);
    }
  }, {
    key: "removeOptionRow",
    value: function removeOptionRow(index) {
      var this_element = this.state.element;
      this_element.table_rows.splice(index, 1);
      this.updateTableOption(this_element);
    }
  }, {
    key: "addOptionColumns",
    value: function addOptionColumns(index) {
        var this_element = this.state.element;
        this_element.table_columns.splice(index + 1, 0, '');
        this.updateTableOption(this_element);
    }
  }, {
    key: "removeOptionColumns",
    value: function removeOptionColumns(index) {
        var this_element = this.state.element;
        this_element.table_columns.splice(index, 1);
        this.updateTableOption(this_element);
    }
  }, {
    key: "addOptionDropdown",
    value: function addOptionDropdown(index) {
      var this_element = this.state.element;
      this_element.dropdown_options.splice(index + 1, 0, {
        value: '',
        text: '',
        key: "dropdown_option_".concat(_UUID["default"].uuid())
      });
      this.props.updateElement.call(this.props.preview, this_element);
    }
  }, {
    key: "removeOptionDropdown",
    value: function removeOptionDropdown(index) {
      var this_element = this.state.element;
      this_element.dropdown_options.splice(index, 1);
      this.props.updateElement.call(this.props.preview, this_element);
    }
  }, {
    key: "changeInputType",
    value: function changeInputType(type) {
      var this_element = this.state.element;
      this_element.input_type = type;
      this.props.updateElement.call(this.props.preview, this_element);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var input_types = ["Multi Choice","Checkbox","Dropdown","Text Input"];

      if (this.state.dirty) {
        this.state.element.dirty = true;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "dynamic-option-list"
      }, 
      this.props.element.input_type && /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/_react["default"].createElement("b", null, 
      'Input Type'
      )))), /*#__PURE__*/_react["default"].createElement("li", {
          className: "clearfix",
        //   key: this_key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-12", // "dynamic-options-actions-buttons"
        }, input_types.map(function (type, index) {

          var buttonStyle = {
            width: '120px'
          }
          if (_this2.props.element.input_type && _this2.props.element.input_type == type) {
            buttonStyle = {
              width: '120px',
              backgroundColor: '#218838',
              borderColor: '#1e7e34',
              boxShadow: '0 0 0 0.2rem rgb(72 180 97 / 50%)'
            }
          }

          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "", // "dynamic-options-actions-buttons"
          }, /*#__PURE__*/_react["default"].createElement("button", {
            onClick: _this2.changeInputType.bind(_this2, type),
            className: "btn btn-success",
            style: buttonStyle,
          }, type))
        }))))
      ),
      /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/_react["default"].createElement("b", null, 
      'Rows'
      )))), this.props.element.table_rows.map(function (option, index) {
        // var this_key = "edit_".concat(option.key);
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "clearfix",
        //   key: this_key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-8"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          tabIndex: index + 1,
          className: "form-control",
          style: {
            width: '100%'
          },
          type: "text",
          name: "text_".concat(index),
          placeholder: "Row text",
          value: option,
          onBlur: _this2.updateOption.bind(_this2),
          onChange: _this2.editOptionRow.bind(_this2, index)
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-4"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "dynamic-options-actions-buttons"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this2.addOptionRow.bind(_this2, index),
          className: "btn btn-success"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-plus-circle"
        })), index > 0 && /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this2.removeOptionRow.bind(_this2, index),
          className: "btn btn-danger"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-minus-circle"
        }))))));
      })), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/_react["default"].createElement("b", null, 
      'Columns'
      )))), this.props.element.table_columns.map(function (option, index) {
        // var this_key = "edit_".concat(option.key);
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "clearfix",
        //   key: this_key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-8"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          tabIndex: index + 1,
          className: "form-control",
          style: {
            width: '100%'
          },
          type: "text",
          name: "text_".concat(index),
          placeholder: "Column text",
          value: option,
          onBlur: _this2.updateOption.bind(_this2),
          onChange: _this2.editOptionColumns.bind(_this2, index)
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-4"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "dynamic-options-actions-buttons"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this2.addOptionColumns.bind(_this2, index),
          className: "btn btn-success"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-plus-circle"
        })), index > 0 && /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this2.removeOptionColumns.bind(_this2, index),
          className: "btn btn-danger"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-minus-circle"
        }))))));
      }))
      , ((this.props.element.input_type && this.props.element.input_type == 'Dropdown') || (!this.props.element.input_type && this.props.element.dropdown_options)) && /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/_react["default"].createElement("b", null, 
      'Dropdown Options'
      )))), this.props.element.dropdown_options.map(function (option, index) {
        // var this_key = "edit_".concat(option.key);
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "clearfix",
        //   key: this_key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-8"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          tabIndex: index + 1,
          className: "form-control",
          style: {
            width: '100%'
          },
          type: "text",
          name: "text_".concat(index),
          placeholder: "Column text",
          value: option.text,
          onBlur: _this2.updateOption.bind(_this2),
          onChange: _this2.editOptionDropdown.bind(_this2, index)
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-4"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "dynamic-options-actions-buttons"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this2.addOptionDropdown.bind(_this2, index),
          className: "btn btn-success"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-plus-circle"
        })), index > 0 && /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this2.removeOptionDropdown.bind(_this2, index),
          className: "btn btn-danger"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-minus-circle"
        }))))));
      }))
      );
    }
  }]);
  return DynamicTableOptionList;
}(_react["default"].Component);

exports["default"] = DynamicTableOptionList;
